import { useTranslation } from "react-i18next";
import Pic from "@/components/common/Pic";

const GuideSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split('-')[0]?.split('@')[0] || 'en';
  
  const exploreItems = [
    {
      name: "Beaches",
      description: "Crystal-clear waters and hidden coves",
      image: "/images/guide/g01.webp",
      link: "https://guidetoarrabida.pt"
    },
    {
      name: "Landmarks",
      description: "Scenic paths through the natural park",
      image: "/images/guide/g02.webp",
      link: "https://guidetoarrabida.pt"
    },
    {
      name: "Wine & Gastronomy",
      description: "Local wines and traditional cuisine",
      image: "/images/guide/g03.webp",
      link: "https://guidetoarrabida.pt"
    },
    {
      name: "Marine Life",
      description: "Dolphins, diving and coastal wonders",
      image: "/images/guide/g04.webp",
      link: "https://guidetoarrabida.pt"
    }
  ];
  
  return (
    <section className="py-16 md:py-24 bg-[#f5f0e8]" data-testid="guide-section">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="pretitle">Explore Arrábida</span>
          <h2 className="font-sans text-2xl md:text-3xl text-[#33685F] font-semibold mb-4">
            An Enchanted Place on Earth
          </h2>
          <p className="font-sans text-sm md:text-base text-[#48756B] max-w-2xl mx-auto">
            Discover the magic of the Arrábida Natural Park — pristine beaches, ancient monasteries, scenic hiking trails, and a rich culinary heritage waiting to be explored. We created an extensive and comprehensive guide to Arrábida, so you can discover all the amazing things you can explore during your stay.
          </p>
        </div>
        
        {/* Explore Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-8">
          {exploreItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="relative aspect-square overflow-hidden rounded-lg mb-3">
                <Pic
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="font-sans text-[#33685F] font-medium text-sm md:text-base">
                {item.name}
              </h3>
              <p className="font-sans text-[#48756B] text-xs md:text-sm">
                {item.description}
              </p>
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a 
            href="https://guidetoarrabida.pt"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#33685F] text-white rounded-lg font-medium hover:bg-[#2a5750] transition-colors"
            data-testid="guide-link"
          >
            Explore the Full Guide
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GuideSection;
